import angular from 'angular';
import { EnvironmentService } from '../../../../environment';

export default angular
  .module('app.directives.branding-image', [EnvironmentService.name])
  .service('BrandingTransforms', BrandingTransforms)
  .directive('brandingImage', BrandingImage);

const UPDATER_LOGO_ID = 'v1408652453/company_logo_1';

function BrandingTransforms(updEnvironment) {
  let transformations = {
    brokerage: 'c_pad,h_140',
    moving: 'c_pad,h_140',
    mortgage: 'c_pad,h_140',
    agent: 'c_fill,w_240,h_240,g_face',
    cobranded_agent: 'c_fill,w_240,h_240,g_face',
    share_company: 'c_pad,h_50',
    share_agent: 'c_fill,w_50,h_50,g_face',
  };

  this.buildUrl = (id = UPDATER_LOGO_ID, type = 'brokerage') => {
    let transformation = transformations[type] || transformations.brokerage;
    return `${updEnvironment.endpoints.cloudinary}/${transformation}/${id}.png`;
  };
}

function BrandingImage(BrandingTransforms) {
  return {
    restrict: 'A',
    scope: {
      entity: '=brandingImage',
    },
    link: linkFn,
  };

  function linkFn(scope, element, attrs) {
    let entity = scope.entity;

    // Allow the transformation type to be overridden on an element by element basis
    let transformType = attrs.brandingTransformationType || entity.kind;

    element.attr(
      'src',
      BrandingTransforms.buildUrl(entity.logo_id, transformType)
    );
  }
}
